module.exports = __webpack_public_path__ + "media/images/icons/calendar-ddd3ec01e2e042229f6de8566e286da0.svg";